import _ from "lodash";
import Loadable from "../components/Common/Loadable";
import { LABEL_KELAS, LABEL_MAPEL, LABEL_MURID, LABEL_SEKOLAH } from "../helpers/constant";

import Pengaturan from "../views/Pengaturan/Index";

const Profil = Loadable(() => import("../views/Profil"));

// const PrintToPDF = Loadable(() => import("../templates/BankSoal/DetilSoal/PrintToPDF"));

const DaftarHasil = Loadable(() => import('../views/Hasil/DaftarHasil/DaftarHasil'));
const InputIsian = Loadable(() => import('../views/Hasil/InputNilai/Isian'));
const InputUraian = Loadable(() => import('../views/Hasil/InputNilai/Uraian'));
const DetilNilai = Loadable(() => import('../views/Hasil/DetilNilai/DetilNilai'));
const DaftarHasilPaket = Loadable(() => import('../views/Hasil/DaftarHasil/DaftarHasilPaket'));
const DetilNilaiPaket = Loadable(() => import('../views/Hasil/DetilNilai/DetilNilaiPaket'));
const DetilNilaiPeserta = Loadable(() => import('../views/Hasil/DetilNilaiPeserta/DetilNilaiPeserta'));

const DetilSesi = Loadable(() => import('../views/Jadwal/DetilSesi/DetilSesi'));
const DetilSoalSnapshot = Loadable(() => import('../views/Jadwal/DetilSoalSnapshot/DetilSoalSnapshot'));
const JadwalBaru = Loadable(() => import('../views/Jadwal/JadwalBaru/JadwalBaru'));
const DetilJadwal = Loadable(() => import('../views/Jadwal/DetilJadwal/DetilJadwal'));
const DaftarJadwal = Loadable(() => import('../views/Jadwal/DaftarJadwal/DaftarJadwal'));

const DetilPaket = Loadable(() => import('../views/BankSoal/DetilPaket/DetilPaket'));
const DaftarPaket = Loadable(() => import('../views/BankSoal/DaftarPaket/DaftarPaket'));
const DaftarPaketBaru = Loadable(() => import('../views/BankSoal/DaftarPaketBaru/DaftarPaketBaru'));

const DetilSoal = Loadable(() => import('../views/BankSoal/DetilSoal/DetilSoal'));

const listRoute = [
	{ path: ['/profil'].join('/'), component: Profil },

	{	path: ['/jadwal'].join('/'), component: DaftarJadwal },
	{	path: ['/jadwal', 'baru'].join('/'), component: JadwalBaru },
	{	path: ['/jadwal', ':jadwal_id'].join('/'), component: DetilJadwal },
	{	path: ['/jadwal', ':jadwal_id', 'snapshot'].join('/'), component: DetilSoalSnapshot, header: false  },
	{	path: ['/jadwal', ':jadwal_id', ':sesi_id'].join('/'), component: DetilSesi },

	{	path: ['/bank-soal'].join('/'), component: DaftarPaket },
	{	path: ['/bank-soal','baru'].join('/'), component: DaftarPaketBaru },
	{	path: ['/bank-soal',':paket_id'].join('/'), component: DetilPaket },
	{	path: ['/bank-soal', 'soal',':paket_id'].join('/'), component: DetilSoal },
	// {	path: ['/bank-soal', 'cetak-soal',':paket_id'].join('/'), component: PrintToPDF },
	{	path: ['/bank-soal', ':paket_id', 'soal'].join('/'), component: DetilSoal, header: false },
	
	{	path: ['/hasil-ujian'].join('/'), component: DaftarHasil },
	{	path: ['/hasil-ujian', 'paket'].join('/'), component: DaftarHasilPaket },
	{	path: ['/hasil-ujian', ':ujian_id'].join('/'), component: DetilNilai },
	{	path: ['/hasil-ujian', ':ujian_id', "isian"].join('/'), component: InputIsian },
	{	path: ['/hasil-ujian', ':ujian_id', "uraian"].join('/'), component: InputUraian },
	{	path: ['/hasil-ujian', 'paket', ':ujian_id'].join('/'), component: DetilNilaiPaket },
	{	path: ['/hasil-ujian', `${_.toLower(LABEL_MURID)}`, ':lembar_jawab_id'].join('/'), component: DetilNilaiPeserta },

	{	path: ['/pengaturan', `akun-${_.toLower(LABEL_MURID)}`].join('/'), component: Pengaturan.DaftarMurid },
	{	path: ['/pengaturan', `akun-${_.toLower(LABEL_MURID)}`, ':murid_id'].join('/'), component: Pengaturan.DetilAkunMurid },
	{	path: ['/pengaturan', 'akun-karyawan'].join('/'), component: Pengaturan.DaftarKaryawan },
	{	path: ['/pengaturan', 'akun-karyawan', ':karyawan_id'].join('/'), component: Pengaturan.DetilAkunKaryawan },
	// {	path: ['/pengaturan', 'statistik-penggunaan'].join('/'), component: Pengaturan.StatistikPenggunaan },
	{	path: ['/pengaturan', `daftar-${_.toLower(LABEL_MAPEL)}`].join('/'), component: Pengaturan.DaftarMapel },
	// {	path: ['/pengaturan', 'daftar-mapel', ':mapel_id'].join('/'), component: Pengaturan.DetilMapel },
	{	path: ['/pengaturan', `identitas-${_.toLower(LABEL_SEKOLAH)}`].join('/'), component: Pengaturan.IdentitasSekolah },
	{	path: ['/pengaturan', `daftar-${_.toLower(LABEL_KELAS)}`].join('/'), component: Pengaturan.DaftarKelas },
	{	path: ['/pengaturan', `daftar-${_.toLower(LABEL_KELAS)}`, `tambah-${_.toLower(LABEL_KELAS)}`].join('/'), component: Pengaturan.TambahKelas },
	{	path: ['/pengaturan', `daftar-${_.toLower(LABEL_KELAS)}`, ':kelas_id'].join('/'), component: Pengaturan.DetilKelas },
	// { path: ['/pengumuman'].join('/'), component: Pengumuman.DaftarPengumumanView },
	// { path: ['/pengumuman', ':id'].join('/'), component: Pengumuman.DetilPengumumanView }
];

export default listRoute;